import React from 'react';
import { Link } from 'react-router-dom';
import GoodsBanner from "../../assets/goods/banner-image/goods-banner.webp";

export default function HeroBanner() {
  return (
    <div className="relative w-full h-[70vh] mt-10">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={GoodsBanner}
          alt="Kitchen Appliances"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Overlay & Content */}
      <div className="relative flex flex-col justify-center items-start h-full p-8 md:p-12 bg-gradient-to-r from-white/80 to-transparent">
        <div className="max-w-md">
          <p className="text-sm md:text-base mb-2 text-gray-700">Premium Kitchen Appliances</p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-gray-900">Up to 30% off Selected Items</h2>
          <Link
            to="/products/kitchen-appliances"
            className="inline-flex items-center text-sm md:text-base font-medium text-[#ff9906] hover:text-[#e68a00]"
          >
            Shop Now
            <svg
              className="ml-2 w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
}
